import { message } from "ant-design-vue";
import request, {
  IPage,
  IWorkspaceResponse,
  IListWorkspaceResponse,
} from "/@/api/http/request";
import { TaskType, TaskStatus, OutOfControlAction } from "/@/types/task";
import { WaylineType } from "/@/types/wayline";
import { ELocalStorageKey } from "/@/types";
const HTTP_PREFIX = "/wayline/api/v1";
const workspaceIds: string =
  localStorage.getItem(ELocalStorageKey.WorkspaceId) || "";
// Get Wayline Files
export const getWaylineFiles = async function (
  wid: string,
  body: any,
  formState: any,
  folderId?: string | number
): Promise<IWorkspaceResponse<any>> {
  const sn = formState.sn ? formState.sn : "";
  let url = `${HTTP_PREFIX}/workspaces/${wid}/waylines?order_by=${body.order_by}&page=${body.page}&page_size=${body.page_size}&keyWord=${formState.keyWord}&sn=${sn}`;
  if (folderId) {
    url += `&folderId=${folderId}`;
  }
  const result = await request.get(url);
  return result.data;
};
// 编辑航线
export const editWayline = async function (
  wid: string,
  waylineId: string
): Promise<IWorkspaceResponse<any>> {
  // const url = `${HTTP_PREFIX}/workspaces/${wid}/waylines/${waylineId}/analysis`
  const url = `${HTTP_PREFIX}/workspaces/${wid}/waylines/${waylineId}/analysis1`;
  const result = await request.get(url);
  return result.data;
};
// 获取所有航线
export const getWaylineAllList = async function (
  wid: string,
): Promise<any> {
  const url = `${HTTP_PREFIX}/workspaces/${wid}/waylines/all`;
  const result = await request.get(url);
  return result.data;
};

// Download Wayline File
export const downloadWaylineFile = async function (
  workspaceId: string,
  waylineId: string
): Promise<any> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/waylines/${waylineId}/url`;
  const result = await request.get(url, { responseType: "blob" });
  if (result.data.type === "application/json") {
    const reader = new FileReader();
    reader.onload = function (e) {
      const text = reader.result as string;
      const result = JSON.parse(text);
      message.error(result.message);
    };
    reader.readAsText(result.data, "utf-8");
  } else {
    return result.data;
  }
};

// Delete Wayline File
export const deleteWaylineFile = async function (
  workspaceId: string,
  waylineId: string
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/waylines/${waylineId}`;
  const result = await request.delete(url);
  return result.data;
};

export interface CreatePlan {
  name: string;
  file_id: string;
  dock_sn: string;
  task_type: TaskType; // 任务类型
  wayline_type: WaylineType; // 航线类型
  execute_time?: number; // 执行时间（毫秒）
  // task_days?: number[] // 执行任务的日期（秒）
  // task_periods?: number[][] // 执行任务的时间点（秒）
  rth_altitude: number; // 相对机场返航高度 20 - 500
  out_of_control_action: OutOfControlAction; // 失控动作
}

// Create Wayline Job
export const createPlan = async function (
  workspaceId: string,
  plan: CreatePlan
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/flight-tasks`;
  const result = await request.post(url, plan);
  return result.data;
};
// 编辑
export const createPlanEdit = async function (
  workspaceId: string,
  jobId: string,
  plan: CreatePlan
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/flight-tasks/${jobId}`;
  const result = await request.post(url, plan);
  return result.data;
};
// 开始
export const createPlanStart = async function (
  workspaceId: string,
  jobId: string,
  plan: CreatePlan
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/start/${jobId}`;
  const result = await request.post(url, plan);
  return result.data;
};
// 新增航线
export const updateLine = async (
  body: any
): Promise<IWorkspaceResponse<any>> => {
  // wayline/api/v1/workspaces/waylines/34bc624b-9e0b-41c4-b301-2d2c27178fdb/file/update
  const url = `${HTTP_PREFIX}/workspaces/waylines/${body.ids}/file/update`;
  const result = await request.post(url, body);
  return result.data;
};
export interface Task {
  job_id: string;
  job_name: string;
  task_type: TaskType; // 任务类型
  file_id: string; // 航线文件id
  file_name: string; // 航线名称
  wayline_type: WaylineType; // 航线类型
  dock_sn: string;
  dock_name: string;
  workspace_id: string;
  username: string;
  begin_time: string;
  end_time: string;
  execute_time: string;
  completed_time: string;
  status: TaskStatus; // 任务状态
  progress: number; // 执行进度
  code: number; // 错误码
  rth_altitude: number; // 相对机场返航高度 20 - 500
  out_of_control_action: OutOfControlAction; // 失控动作
  media_count: number; // 媒体数量
  uploading: boolean; // 是否正在上传媒体
  uploaded_count: number; // 已上传媒体数量
}

// Get Wayline Jobs
export const getWaylineJobs = async function (
  workspaceId: string,
  page: IPage,
  formState?: any
): Promise<IListWorkspaceResponse<Task>> {
  let day = formState.day ? formState.day : "";
  let rwmc = formState.rwmc ? formState.rwmc : "";
  let jcmc = formState.jcmc ? formState.jcmc : "";
  let hxmc = formState.hxmc ? formState.hxmc : "";
  let sps = formState.sps ? formState.sps : ""; // 水平里程
  let spe = formState.spe ? formState.spe : ""; // 水平里程
  let czs = formState.czs ? formState.czs : ""; // 垂直里程
  let cze = formState.cze ? formState.cze : ""; // 垂直里程
  let zt = formState.zt ? formState.zt : ""; // 状态
  let startTime = formState.startTime ? formState.startTime : ""; // 开始时间
  let endTime = formState.endTime ? formState.endTime : ""; // 结束时间
  let statusJob = formState.statusJob ? formState.statusJob : ""; // 排序
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/jobs?page=${page.page}&page_size=${page.page_size}&keyWord=${formState.keyWord}&category=${formState.category}&sn=${formState.dockSn}&day=${day}&rwmc=${rwmc}&jcmc=${jcmc}&hxmc=${hxmc}&sps=${sps}&spe=${spe}&czs=${czs}&cze=${cze}&zt=${zt}&executionStart=${startTime}&executionEnd=${endTime}&statusJob=${statusJob}`;
  const result = await request.get(url);
  return result.data;
};
// 获取任务总时长
export const getWaylineJobsTime = async function (
  workspaceId: string,
  page: IPage,
  formState?: any
): Promise<IListWorkspaceResponse<Task>> {
  let day = formState.day ? formState.day : "";
  let rwmc = formState.rwmc ? formState.rwmc : "";
  let jcmc = formState.jcmc ? formState.jcmc : "";
  let hxmc = formState.hxmc ? formState.hxmc : "";
  let sps = formState.sps ? formState.sps : ""; // 水平里程
  let spe = formState.spe ? formState.spe : ""; // 水平里程
  let czs = formState.czs ? formState.czs : ""; // 垂直里程
  let cze = formState.cze ? formState.cze : ""; // 垂直里程
  let zt = formState.zt ? formState.zt : ""; // 状态
  let startTime = formState.startTime ? formState.startTime : ""; // 开始时间
  let endTime = formState.endTime ? formState.endTime : ""; // 结束时间
  let statusJob = formState.statusJob ? formState.statusJob : ""; // 排序
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/jobs/time?page=${page.page}&page_size=${page.page_size}&keyWord=${formState.keyWord}&category=${formState.category}&sn=${formState.dockSn}&day=${day}&rwmc=${rwmc}&jcmc=${jcmc}&hxmc=${hxmc}&sps=${sps}&spe=${spe}&czs=${czs}&cze=${cze}&zt=${zt}&executionStart=${startTime}&executionEnd=${endTime}&statusJob=${statusJob}`;
  const result = await request.get(url);
  return result.data;
};

export interface DeleteTaskParams {
  job_id: string;
}

// 删除/取消机场任务
export async function deleteTask(
  workspaceId: string,
  params: DeleteTaskParams
): Promise<IWorkspaceResponse<{}>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/jobs`;
  const result = await request.delete(url, {
    params: params,
  });
  return result.data;
}
export enum UpdateTaskStatus {
  Suspend = 0, // 暂停
  Resume = 1, // 恢复
}
export interface UpdateTaskStatusBody {
  job_id: string;
  status: UpdateTaskStatus;
}

// 更新机场任务状态
export async function updateTaskStatus(
  workspaceId: string,
  body: UpdateTaskStatusBody
): Promise<IWorkspaceResponse<{}>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/jobs/${body.job_id}`;
  const result = await request.put(url, {
    status: body.status,
  });
  return result.data;
}
export async function deleteTaskDel(
  workspaceId: string,
  params: DeleteTaskParams
): Promise<IWorkspaceResponse<{}>> {
  // console.log(107,params);

  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/jobs/${params.job_id}`;
  const result = await request.delete(url, {});
  return result.data;
}
// 批量删除
export async function pitchDelApi(workspaceId: string, params: any) {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/jobs/delete?jobIds=${params.jobIds}`;
  const result = await request.get(url, {});
  return result.data;
}

// Upload Wayline file
export const importKmzFile = async function (
  workspaceId: string,
  file: {}
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/waylines/file/upload`;
  const result = await request.post(url, file, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return result.data;
};

// 媒体立即上传
export const uploadMediaFileNow = async function (
  workspaceId: string,
  jobId: string
): Promise<IWorkspaceResponse<{}>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/jobs/${jobId}/media-highest`;
  const result = await request.post(url);
  return result.data;
};
// 获取网格列表
export const getGridList = async function (
  startTime: any,
  endTime: any,
  selectvalue: any,
  workspaceId: string,
  types: boolean
) {
  // //gridding/list/data/calibration?startTime=2023-05-30 14:31:48&endTime=2023-05-30 14:31:49&serial=c7269d11
  // types 为true 校准后的数据
  let urlheader = "";
  // console.log(176,types);

  if (types) {
    urlheader = "/gridding/list/data/calibration";
  } else {
    urlheader = "/gridding/list/data6";
  }
  const url = `${urlheader}?startTime=${startTime}&endTime=${endTime}&serial=${selectvalue}&workspace=${workspaceId}`;
  // const url = `/gridding/list?page=1&page_size=99999`
  const result = await request.get(url);
  return result.data;
};
// 获取设备
export const getdeviceList = async function (workspaceId: string) {
  const url = `/gridding/equipment/choose?workspace=${workspaceId}`;
  // const url = `/gridding/list?page=1&page_size=99999`
  const result = await request.get(url);
  return result.data;
};
// 机场初始化在执行的航线
export const initWayApi = async function (workspaceId: string, sn: any) {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/running/job/${sn}`;
  const result = await request.get(url);
  return result.data;
};
// 获取正在执行手控的航点信息
export const initAimApi = async function (sn: any) {
  const url = `manualLog/getBySn?sn=${sn}`;
  const result = await request.get(url);
  return result.data;
};
// 机场 飞机均为空闲时,清空数据
export const clearAimApi = async function (sn: any) {
  const url = `manualLog/end?sn=${sn}`;
  const result = await request.get(url);
  return result.data;
};
// 点击 网格获取数据
export const getGridDataApi = async function (
  id: any,
  startTime: any,
  endTime: any,
  selectvalue: any,
  calibration: boolean,
  page: any
) {
  const url = `/gridding/detail?id=${id}&startTime=${startTime}&endTime=${endTime}&serial=${selectvalue}&calibration=${calibration}&page=${page.page}&pageSize=${page.pageSize}`;
  const result = await request.get(url);
  return result.data;
};
// 点击 网格获取空气站点数据
export const getstationDataApi = async function () {
  const url = `/gridding/station`;
  const result = await request.get(url);
  return result.data;
};
// 点击 校准
export const calibrationApi = async function (params: any) {
  const url = `/gridding/station/data/calibration?id=${params.id}&mn=${params.mn}&serial=${params.serial}&startTime=${params.startTime}&endTime=${params.endTime}&time=${params.time}`;
  const result = await request.get(url);
  return result.data;
};
// 点击 设置校准点
export const setcalibrationApi = async function (id: any) {
  const url = `/gridding/set/calibration?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 点击 删除点
export const delcalibrationApi = async function (id: any) {
  const url = `/gridding/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 空气站点时间倒推最新数据
export const lastTimeAirApi = async function (mn: any, time: any, id: any) {
  // /gridding/station/data/lastTime?mn=51010401001&time=2023-05-31 14:26:45
  const url = `/gridding/station/data/lastTime?mn=${mn}&time=${time}&id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 获取在线设备的机场视频
export const onlineDeviceApi = async function (sn: any) {
  const url = `gb28181/remote?sn=${sn}`;
  const result = await request.get(url);
  return result.data;
};
// 输入地址，查询下拉框
export const getAddressTipApi = async function (keyWords: any) {
  const url = `receivingaAlarm/inputPrompt?keyWords=${keyWords}`;
  const result = await request.get(url);
  return result.data;
};
// 根据地址，返回经纬度
export const getAddressLngApi = async function (keyWords: any, dock: any) {
  const url = `receivingaAlarm/getLngAndLat?address=${keyWords}&sn=${dock.sn}&sLon=${dock.lng}&sLat=${dock.lat}`;
  const result = await request.get(url);
  return result.data;
};
// 根据经纬度，返回地址
export const getLngToAddressApi = async function (pos: any, dock: any) {
  // receivingaAlarm/getAddressByJWD?lon=104.144772&lat=30.605987&sn=&sLon=&sLat=
  const url = `receivingaAlarm/getAddressByJWD?lon=${pos[0]}&lat=${pos[1]}&sn=${dock.sn}&sLon=${dock.lng}&sLat=${dock.lat}`;
  const result = await request.get(url);
  return result.data;
};
// 警情任务 动作模板分页查询 所有
export const getTemplateApi = async function (sn?: any) {
  const url = `warning/template/page?current=1&size=-1&workspaceId=${workspaceIds}&sn=${sn}`;
  const result = await request.get(url);
  return result.data;
};
// 警情任务 动作模板 分页查询
export const getTemplatePageApi = async function (page: any, name: any) {
  // warning/template/save
  const url = `warning/template/page?current=${page.page}&size=${page.page_size}&template_name=${name}`;
  const result = await request.get(url);
  return result.data;
};
// 警情任务 根据模板id获取数据
export const getTemplateOneApi = async function (id: number) {
  const url = `warning/template/findById?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 警情任务 动作模板 新增
export const addTemplateApi = async (body: any): Promise<any> => {
  const url = `warning/template/save`;
  const result = await request.post(url, body);
  return result.data;
};
// 警情任务 动作模板 编辑
export const updateTemplateApi = async (body: any): Promise<any> => {
  const url = `warning/template/update`;
  const result = await request.post(url, body);
  return result.data;
};
// 警情任务 动作模板 编辑
export const delTemplateApi = async (body: any): Promise<any> => {
  const url = `warning/template/delete`;
  const result = await request.post(url, body);
  return result.data;
};
// 警情任务 新增
export const addWarnTaskApi = async (
  body: any
): Promise<IWorkspaceResponse<any>> => {
  const url = `receivingaAlarm/save`;
  const result = await request.post(url, body);
  return result.data;
};
// 机场限制 新增
export const addScopeLimitApi = async (
  body: any
): Promise<IWorkspaceResponse<any>> => {
  const url = `scopeLimit/save`;
  const result = await request.post(url, body);
  return result.data;
};
// 机场限制 编辑
export const updateScopeLimitApi = async (
  body: any
): Promise<IWorkspaceResponse<any>> => {
  const url = `scopeLimit/update`;
  const result = await request.post(url, body);
  return result.data;
};
// 机场限制 查询列表
export const getScopeLimitApi = async (params: any): Promise<any> => {
  const url = `scopeLimit/page?sn=${params.sn}&workspace_id=${workspaceIds}&current=${params.current}&size=${params.size}`;
  const result = await request.get(url);
  return result.data;
};
// 重新执行失败的警情任务
export const resetWarnApi = async (jobId: any): Promise<any> => {
  const url = `receivingaAlarm/restart?jobId=${jobId}`;
  const result = await request.get(url);
  return result.data;
};
// 机场限制 查询单个
export const getOneScopeLimitApi = async (id: any): Promise<any> => {
  const url = `scopeLimit/findById?id=${id}`;
  const result = await request.get(url);
  return result.data;
};
// 键盘事件 用于显示飞行姿态
export const getManualApi = async (params: any): Promise<any> => {
  const url = `manualLog/manual?sn=${params.sn}&key=${params.key}&action=${params.action}`;
  const result = await request.get(url);
  return result.data;
};
// 任务id获得航线轨迹信息
export const getAirLineApi = async (jobId: string) => {
  const url = `mediaFile/airLine?jobId=${jobId}`;
  const result = await request.get(url);
  return result.data;
};
// 文件信息获取飞机位置
export const getAirPositionApi = async (params: any) => {
  const url = `mediaFile/aircraftLocation?jobId=${params.jobId}&time=${params.time}&sec=${params.sec}`;
  const result = await request.get(url);
  return result.data;
};
// 任务飞行轨迹 飞行记录回放
export const getAirTrackApi = async (jobId: any) => {
  const url = `mediaFile/track?jobId=${jobId}`;
  const result = await request.get(url);
  return result.data;
};
// 告警事件实时汇报列表
export const getJobTaskApi = async (params: any) => {
  let jobid = params.jobid ? params.jobid : "";
  let fileId = params.file_id ? params.file_id : "";
  let vmlr1_find = params.vmlr1_find
    ? params.vmlr1_find
    : params.vmlr1_find == 0
    ? 0
    : "";
  let vmlr1Type = params.vmlr1Type
    ? params.vmlr1Type
    : params.vmlr1Type == 0
    ? 0
    : "";
  let isFixed = params.isFixed ? params.isFixed : params.isFixed == 0 ? 0 : "";
  const url = `JobTask/page?current=${params.current}&size=${params.size}&workspace=${params.workspace}&type=${params.type}&aiType=${params.aiType}&jobId=${jobid}&file_id=${fileId}&vmlr1_find=${vmlr1_find}&isFixed=${isFixed}&vmlr1_type=${vmlr1Type}`;
  const result = await request.get(url);
  return result.data;
};
// 告警事件实时 -- 立即处理
export const getJobSendApi = async (id: any, img = "") => {
  let body = {
    id,
    img,
  };
  const url = `JobTask/send`;
  const result = await request.post(url, body);
  return result.data;
};
// 告警事件实时 -- 立即处理
export const updateJobSendApi = async (data: any) => {
  const url = `JobTask/update`;
  const result = await request.post(url, data);
  return result.data;
};
// 告警事件实时 -- 告警详情
export const getOneTaskApi = async (rerId: any) => {
  const url = `workspaces/getOneTask?rerId=${rerId}`;
  const result = await request.get(url);
  return result.data;
};
// 告警事件实时 -- 任务派发流程
export const getOneReportHistoryApi = async (prsId: any) => {
  const url = `workspaces/reportHistory?prsId=${prsId}`;
  const result = await request.get(url);
  return result.data;
};
// 飞行统计
export const getCountListApi = async (workspaceId: any, params: any) => {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/jobs/count?sn=${params.sn}&sTime=${params.sTime}&eTime=${params.eTime}`;
  const result = await request.get(url);
  return result.data;
};

// 获取文件夹列表
export const getWaylineFolders = async function (
  workspaceId: string
): Promise<IWorkspaceResponse<any>> {
  const url = `WaylineFileFolder/all?workspaceId=${workspaceId}`;
  const result = await request.get(url);
  return result.data;
};

// 新增文件夹
export const saveWaylineFolderApi = async function (
  body: any
): Promise<IWorkspaceResponse<any>> {
  const url = `WaylineFileFolder/save`;
  const result = await request.post(url, body);
  return result.data;
};

// 修改文件夹名称
export const updateWaylineFolderApi = async function (
  body: any
): Promise<IWorkspaceResponse<any>> {
  const url = `WaylineFileFolder/update`;
  const result = await request.post(url, body);
  return result.data;
};

// 删除文件夹
export const deleteWaylineFolderApi = async function (
  id: number | string
): Promise<IWorkspaceResponse<any>> {
  const url = `WaylineFileFolder/delete?id=${id}`;
  const result = await request.get(url);
  return result.data;
};

// 移动航线到文件夹
export const moveWaylineFileApi = async function (
  id: string | number,
  fileId: string | number
): Promise<IWorkspaceResponse<any>> {
  const url = `WaylineFileFolder/move?fileId=${id}&folderId=${fileId}`;
  const result = await request.get(url);
  return result.data;
};

// 获取网格分页数据
export const getNetworkGridPage = async function (
  workspaceId: string,
  current: number = 1,
  size: number = 10
): Promise<any> {
  const url = `NetworkGrid/page?current=${current}&size=${size}&workspace=${workspaceId}`;
  const result = await request.get(url);
  return result.data;
};

// 获取网格详情数据
export const getGridDetailApi = async function (
  id: any,
  startTime: string,
  endTime: string,
  serial: string,
  page: number,
  pageSize: number
) {
  const url = `/gridding/detail6?id=${id}&startTime=${startTime}&endTime=${endTime}&serial=${serial}&page=${page}&pageSize=${pageSize}`;
  const result = await request.get(url);
  return result.data;
};

// 生成航点报告
export const exportReportApi = async function (params: {
  jobId: string;
  waylineImg: string;
  satelliteImg: string;
  northEast: string;
  southWest: string;
  southEast: string;
  northWest: string;
}): Promise<IWorkspaceResponse<any>> {
  const url = `AeroSpotFile/export?jobId=${params.jobId}&waylineImg=${params.waylineImg}&satelliteImg=${params.satelliteImg}&northEast=${params.northEast}&southWest=${params.southWest}&southEast=${params.southEast}&northWest=${params.northWest}`;
  const result = await request.get(url);
  return result.data;
};

// 巡逻航线预览
export const previewPatrolWayline = async function (
  workspaceId: string,
  data: any
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/waylines/target-detection/preview`;
  const result = await request.post(url, data);
  return result.data;
};

// 巡逻航线生成
export const createPatrolWayline = async function (
  workspaceId: string,
  data: any
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/waylines/target-detection`;
  const result = await request.post(url, data);
  return result.data;
};

// 编辑巡逻航线
export const updatePatrolWayline = async function (
  workspaceId: string,
  waylineId: string,
  data: any
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/waylines/target-detection/${waylineId}/update`;
  const result = await request.post(url, data);
  return result.data;
};
// 面状航线预览
export const previewAreaWayline = async function (
  workspaceId: string,
  data: any
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/waylines/area/preview`;
  const result = await request.post(url, data);
  return result.data;
};

// 面状航线生成
export const createAreaWayline = async function (
  workspaceId: string,
  data: any
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/waylines/area`;
  const result = await request.post(url, data);
  return result.data;
};

// 编辑面状航线
export const updateAreaWayline = async function (
  workspaceId: string,
  waylineId: string,
  data: any
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/waylines/area/${waylineId}/update`;
  const result = await request.post(url, data);
  return result.data;
};

// 带状航线预览
export const previewStripWayline = async function (
  workspaceId: string,
  data: any
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/waylines/strip/preview`;
  const result = await request.post(url, data);
  return result.data;
};

// 带状航线生成
export const createStripWayline = async function (
  workspaceId: string,
  data: any
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/waylines/strip`;
  const result = await request.post(url, data);
  return result.data;
};

// 编辑带状航线
export const updateStripWayline = async function (
  workspaceId: string,
  waylineId: string,
  data: any
): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/waylines/strip/${waylineId}/update`;
  const result = await request.post(url, data);
  return result.data;
};

// 判断是否可生成报告
export const hasExportReportApi = async function (jobId: string): Promise<IWorkspaceResponse<any>> {
  const url = `AeroSpotFile/has/export?jobId=${jobId}`;
  const result = await request.get(url);
  return result.data;
};
